package org.matthewo.pages.team

import org.matthewo.pages.event.EVENT_CODE_PARAM
import org.matthewo.pages.team.tabs.*
import org.matthewo.router.TSRouteBuilder
import org.matthewo.router.div
import tanstack.router.core.ParamName
import tanstack.router.core.RoutePath

val TEAM_PARAM = ParamName("team")

val TEAM_CONTRIBUTION_PLOT_PATH = RoutePath(TEAM_PATH / "contribution")
val TEAM_CONTRIBUTION_PLOT_EVENT_PATH = RoutePath(TEAM_PATH / "contribution" / EVENT_CODE_PARAM)

fun TSRouteBuilder.teamRoutes() {
    TSRoute(TEAM_PATH, SeasonEventsTable)
    TSRoute(TEAM_CONTRIBUTION_PLOT_PATH, TeamContributionPlot)
    TSRoute(TEAM_CONTRIBUTION_PLOT_EVENT_PATH, TeamContributionPlot)
    TSRoute(INTO_THE_DEEP_CRI_PLACEMENT_VISUALIZATION_PATH, IntoTheDeepCRIPlacementVisualization)
}
